import { render, staticRenderFns } from "./ResearchOutputResearchStatementTab.vue?vue&type=template&id=1a882ff0&scoped=true&"
import script from "./ResearchOutputResearchStatementTab.vue?vue&type=script&lang=js&"
export * from "./ResearchOutputResearchStatementTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a882ff0",
  null
  
)

export default component.exports